import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import NavBar from "../../Layout/CommonLayout/NavBar";
import axios from "axios";
import { AppConfiguration } from "read-appsettings-json";
import "./jobspace-account.css";
import { GetRequest, PostRequest } from '../../noser-dataaccess'
import JobSpaceLogo from "../../components/Brand/JobSpaceLogo";

import {Alert, Input} from "reactstrap";
import AWS from "aws-sdk";
import moment from 'moment';
import CurrencyInput from 'react-currency-input-field';


const getCollection = (collection, filter) =>
  axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", {
      _collection: collection,
      filter_data: filter || {},
    })
    .then((res) => parseList((res.data || {})[collection]))
    .catch(() => []);

// Records arrive as Mongo strings ("...ObjectId('..'), 'field':'val'..");
// strip the wrapper and parse a single record (same pattern the app uses).
const parseMongo = (itm) => {
  if (itm == null) return null;
  if (typeof itm !== "string") return itm;
  try {
    const cleaned = itm
      .replace(/ObjectId\(([^)]*)\)/g, "$1") // ObjectId('..') -> '..' (handles nested)
      .replace(/_id/g, "id");
    return JSON.parse(cleaned.replace(/'/g, '"'));
  } catch (e) {
    return null;
  }
};
const parseList = (arr) => (Array.isArray(arr) ? arr.map(parseMongo).filter(Boolean) : []);

// Deterministic monogram tile (the design shows a colored initial for every
// job/company); colors are derived from the name so they stay stable.
const LOGO_PALETTE = [
  { logoBg: "#e8f0ff", logoColor: "#2563d8" }, { logoBg: "#e6f7ee", logoColor: "#00a862" },
  { logoBg: "#eef0ff", logoColor: "#5b3df5" }, { logoBg: "#fff0e6", logoColor: "#e8742a" },
  { logoBg: "#eafaf1", logoColor: "#0a9d58" }, { logoBg: "#fff0ec", logoColor: "#ee4d2d" },
  { logoBg: "#f1ecff", logoColor: "#7c3aed" }, { logoBg: "#ffecec", logoColor: "#d23b30" },
];
const brandOf = (name) => {
  const s = (name || "?").trim();
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h + s.charCodeAt(i)) % LOGO_PALETTE.length;
  return { initial: (s[0] || "?").toUpperCase(), ...LOGO_PALETTE[h] };
};
const titleCase = (s) => (s || "").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
const num = (v) => {
  const n = parseFloat(String(v == null ? "" : v).replace(/,/g, ""));
  return isNaN(n) ? null : n;
};
const peso = (cur, v) => {
  const n = num(v);
  if (n == null) return "";
  const sym = /php|peso|₱/i.test(String(cur || "")) || !cur ? "₱" : titleCase(cur) + " ";
  return sym + n.toLocaleString("en-PH");
};
// "•"/";"/newline-delimited string (or array) → clean list for the detail modal.
const toList = (v) => {

  // let vTmp = v.length > 0 || typeof v !== "undefined" ? v : "";
  if (Array.isArray(v)) return v.map((x) => String(x).trim()).filter(Boolean);
  
  if (typeof v === "string") {
    const parts = v.split(/\r?\n|•|;/).map((x) => x.trim()).filter(Boolean);
    return parts.length ? parts : v.trim() ? [v.trim()] : [];
  }
  return [];
};
const postedLabel = (d) => {
  if (!d) return "Recently posted";
  const t = new Date(d);
  if (isNaN(t.getTime())) return "Recently posted";
  const days = Math.floor((Date.now() - t.getTime()) / 86400000);
  if (days <= 0) return "Posted today";
  if (days === 1) return "Posted 1 day ago";
  if (days < 7) return "Posted " + days + " days ago";
  if (days < 14) return "Posted 1 week ago";
  return "Posted " + t.toLocaleDateString("en-PH", { month: "short", day: "numeric" });
};

// ─────────────────────────────────────────── data (designed content) ──
const COMPANY_PERKS = ["HMO + dependents", "Hybrid / remote work", "13th & 14th month pay", "Learning budget", "Stock options", "Wellness programs", "Paid time off", "Performance bonus"];


const FIELDS_BY_TAB = {
  "General Information": [
    { key: "firstName", label: "First Name" }, { key: "middleName", label: "Middle Name" },
    { key: "lastName", label: "Last Name" }, { key: "birthdate", label: "Date of Birth" },
    { key: "gender", label: "Gender" }, { key: "civil", label: "Civil Status" },
    { key: "nationality", label: "Nationality" }, { key: "phone", label: "Phone" },
    { key: "email", label: "Email", wide: true },
    { key: "headline", label: "Professional Headline", wide: true },
    { key: "address", label: "Address", wide: true },
  ],
  "Education": [
    { key: "school", label: "School / University", wide: true },
    { key: "degree", label: "Degree" }, { key: "fieldOfStudy", label: "Field of Study" },
    { key: "startYear", label: "Start Year" }, { key: "endYear", label: "End Year" },
    { key: "honors", label: "Honors / Achievements", wide: true },
  ],
  "Employment Record": [
    { key: "company", label: "Company" }, { key: "position", label: "Position" },
    { key: "empStart", label: "Start Date" }, { key: "empEnd", label: "End Date" },
    { key: "empLocation", label: "Location" }, { key: "empType", label: "Employment Type" },
    { key: "empDesc", label: "Key Responsibilities", wide: true },
  ],
  "Family Background": [
    { key: "fatherName", label: "Father's Name" }, { key: "fatherOcc", label: "Father's Occupation" },
    { key: "motherName", label: "Mother's Name" }, { key: "motherOcc", label: "Mother's Occupation" },
    { key: "spouse", label: "Spouse's Name" }, { key: "dependents", label: "No. of Dependents" },
    { key: "emergencyName", label: "Emergency Contact" }, { key: "emergencyPhone", label: "Emergency Contact No." },
  ],
  "Others": [
    { key: "skills", label: "Skills", wide: true },
    { key: "languages", label: "Languages" }, { key: "hobbies", label: "Hobbies & Interests" },
    { key: "certs", label: "Certifications", wide: true },
    { key: "portfolio", label: "Portfolio / Website", wide: true },
  ],
  "References": [
    { key: "ref1Name", label: "Full Name", section: "Reference 1" }, { key: "ref1Rel", label: "Relationship", section: "Reference 1" },
    { key: "ref1Company", label: "Company", section: "Reference 1" }, { key: "ref1Contact", label: "Contact Number", section: "Reference 1" },
    { key: "ref1Email", label: "Email", section: "Reference 1", wide: true },
    { key: "ref2Name", label: "Full Name", section: "Reference 2" }, { key: "ref2Rel", label: "Relationship", section: "Reference 2" },
    { key: "ref2Company", label: "Company", section: "Reference 2" }, { key: "ref2Contact", label: "Contact Number", section: "Reference 2" },
    { key: "ref2Email", label: "Email", section: "Reference 2", wide: true },
  ],
};

const FILTER_CONFIG = {
  Salary: ["Any salary", "₱20,000+", "₱40,000+", "₱60,000+", "₱100,000+"],
  "Day(s) posted": ["All","Within the day", "Last 3 days", "Last 7 days", "Last 14 days"],
  Experience: ["Any experience", "Entry level", "1–3 years", "3–5 years", "5+ years"],
};
// thresholds for the dropdown filters (keyed by the option label)
const SALARY_FLOOR = { "₱20,000+": 20000, "₱40,000+": 40000, "₱60,000+": 60000, "₱100,000+": 100000 };
const DATE_DAYS = { "Within the day": 1, "Last 3 days": 3, "Last 7 days": 7, "Last 14 days": 14 };
const EXP_RANGE = { "Entry level": [0, 1], "1–3 years": [1, 3], "3–5 years": [3, 5], "5+ years": [5, 99] };
const SORT_OPTIONS = ["Most relevant", "Newest", "Salary: high to low", "Salary: low to high"];

// ───────────────────────────────────────────────────────── icons ──
const Ic = ({ s = 18, vb = "0 0 24 24", fill = "none", style, children }) => (
  <svg width={s} height={s} viewBox={vb} fill={fill} style={style}>{children}</svg>
);
const Bell = ({ s = 19, stroke = "#3c4d44" }) => (
  <Ic s={s}><path d="M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" stroke={stroke} strokeWidth="1.8" strokeLinejoin="round" /><path d="M10 19a2 2 0 0 0 4 0" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" /></Ic>
);
const Search = ({ s = 19, stroke = "#8a9a91" }) => (
  <Ic s={s}><circle cx="11" cy="11" r="7" stroke={stroke} strokeWidth="2" /><path d="m20 20-3-3" stroke={stroke} strokeWidth="2" strokeLinecap="round" /></Ic>
);
const Pin = ({ s = 17, stroke = "#8a9a91" }) => (
  <Ic s={s}><path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" stroke={stroke} strokeWidth="2" /><circle cx="12" cy="10" r="2.4" stroke={stroke} strokeWidth="2" /></Ic>
);
const Star = ({ s = 16 }) => (
  <Ic s={s} fill="#f5a623"><path d="m12 2 2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7L12 2Z" /></Ic>
);
const Chevron = ({ s = 13, stroke = "#7c8b82", dir = "down" }) => {
  const d = { down: "m6 9 6 6 6-6", right: "M9 6l6 6-6 6", left: "M15 6l-6 6 6 6" }[dir];
  return <Ic s={s}><path d={d} stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></Ic>;
};
const Check = ({ s = 15, stroke = "#fff", w = 2.4 }) => (
  <Ic s={s}><path d="m5 12 4.5 4.5L19 7" stroke={stroke} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round" /></Ic>
);
const Bookmark = ({ s = 16, fill = "none" }) => (
  <Ic s={s} fill={fill}><path d="M6 4.5h12a1 1 0 0 1 1 1V20l-7-4-7 4V5.5a1 1 0 0 1 1-1Z" stroke="#009b57" strokeWidth="1.8" /></Ic>
);
const Close = ({ s = 16 }) => (
  <Ic s={s}><path d="m6 6 12 12M18 6 6 18" stroke="#46564c" strokeWidth="2.2" strokeLinecap="round" /></Ic>
);
const Trash = () => (
  <Ic s={15}><path d="M5 7h14M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m-9 0v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7" stroke="#c0493e" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></Ic>
);
const CheckCircle = () => (
  <Ic s={17} style={{ flex: "none", marginTop: 1 }}><circle cx="12" cy="12" r="10" fill="#ecf7f0" /><path d="m8 12 2.5 2.5L16 9" stroke="#009b57" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></Ic>
);
const Bolt = () => (
  <Ic s={13}><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" fill="#009b57" /></Ic>
);

const CAT_DEFS = [
  { name: "Technology", q: "Engineer", count: "1,240", bg: "#e8f0ff", color: "#2563d8", icon: <Ic s={20}><path d="M9 18l-6-6 6-6m6 12 6-6-6-6" stroke="#2563d8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></Ic> },
  { name: "Design", q: "Designer", count: "420", bg: "#f1ecff", color: "#7c3aed", icon: <Ic s={20}><circle cx="13.5" cy="6.5" r="2.5" stroke="#7c3aed" strokeWidth="1.8" /><circle cx="6.5" cy="11.5" r="2.5" stroke="#7c3aed" strokeWidth="1.8" /><circle cx="16.5" cy="16.5" r="2.5" stroke="#7c3aed" strokeWidth="1.8" /></Ic> },
  { name: "Finance", q: "Analyst", count: "680", bg: "#ecf7f0", color: "#047a45", icon: <Ic s={20}><path d="M4 19V9m5 10V5m5 14v-7m5 7V8" stroke="#047a45" strokeWidth="2" strokeLinecap="round" /></Ic> },
  { name: "Marketing", q: "Marketing", count: "510", bg: "#fff0ec", color: "#ee4d2d", icon: <Ic s={20}><path d="M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1Z" stroke="#ee4d2d" strokeWidth="1.8" strokeLinejoin="round" /><path d="M16 9a3 3 0 0 1 0 6" stroke="#ee4d2d" strokeWidth="1.8" strokeLinecap="round" /></Ic> },
  { name: "Sales", q: "Sales", count: "740", bg: "#fff4e0", color: "#b5701a", icon: <Ic s={20}><path d="M4 13l5 5L20 6" stroke="#b5701a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></Ic> },
  { name: "Customer Service", q: "Customer", count: "390", bg: "#e6f7ee", color: "#00a862", icon: <Ic s={20}><path d="M5 18v-6a7 7 0 0 1 14 0v6" stroke="#00a862" strokeWidth="1.8" strokeLinecap="round" /><rect x="3" y="14" width="4" height="6" rx="2" stroke="#00a862" strokeWidth="1.8" /><rect x="17" y="14" width="4" height="6" rx="2" stroke="#00a862" strokeWidth="1.8" /></Ic> },
  { name: "Healthcare", q: "Health", count: "260", bg: "#ffecec", color: "#d23b30", icon: <Ic s={20}><path d="M12 9v6M9 12h6" stroke="#d23b30" strokeWidth="2" strokeLinecap="round" /><rect x="4" y="4" width="16" height="16" rx="4" stroke="#d23b30" strokeWidth="1.8" /></Ic> },
  { name: "Engineering", q: "Engineer", count: "880", bg: "#eef0ff", color: "#5b3df5", icon: <Ic s={20}><path d="M14 6l4 4-8 8-4 1 1-4 8-8Z" stroke="#5b3df5" strokeWidth="1.8" strokeLinejoin="round" /></Ic> },
];

// ─────────────────────────────────────── small style helpers ──
const pill = (bg, color) => ({ display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 11px", borderRadius: 999, background: bg, fontSize: 12.5, fontWeight: 600, color });
const greenPill = { display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 11px", borderRadius: 999, background: "#ecf7f0", color: "#047a45", fontSize: 12.5, fontWeight: 700 };
const primaryBtn = { border: "none", borderRadius: 100, background: "#009b57", color: "#fff", fontFamily: "inherit", fontWeight: 700, cursor: "pointer" };
const card = { background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 18, padding: 24 };
const sectionTitle = { margin: 0, fontSize: 17, fontWeight: 800 };

// Profile starts blank; fields are populated from the logged-in user's
// CandidatesProfile record (see fetch in the component).
const BLANK_FORM = Object.fromEntries(
  Object.values(FIELDS_BY_TAB).flat().map((f) => [f.key, ""])
);

// ══════════════════════════════════════════════════════ component ══
export default function JobSpaceAccount() {
  const [view, setView] = useState("jobs");
  const [query, setQuery] = useState("");
  const [location, setLocation] = useState("");
  const [activeType, setActiveType] = useState("All");
  const [openFilter, setOpenFilter] = useState(null);
  const [filterValues, setFilterValues] = useState({ Salary: "Any salary", "Day(s) posted": "All", Experience: "Any experience" });
  const [sortBy, setSortBy] = useState("Most relevant");
  const [sortOpen, setSortOpen] = useState(false);
  const [savedJobs, setSavedJobs] = useState({});
  const [selectedJob, setSelectedJob] = useState(null);
  const [companyQuery, setCompanyQuery] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyTab, setCompanyTab] = useState("Snapshot");
  const [followed, setFollowed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [applyOpen, setApplyOpen] = useState(false);
  const [applyStep, setApplyStep] = useState(1);
  const [applyData, setApplyData] = useState({ name: "", phone: "", email: "", note: "", resumeAttached: false, exp: "", auth: "Yes", salary: "", start: "" });
  const [alertsOpen, setAlertsOpen] = useState(false);
  const [alertDraft, setAlertDraft] = useState({ keyword: "", location: "", freq: "Daily" });
  const [alerts, setAlerts] = useState([]);
  const [form, setForm] = useState(BLANK_FORM);
  const [reads, setReads] = useState({});
  const [selectedNotif, setSelectedNotif] = useState(null);
  const [settings, setSettings] = useState({ jobAlerts: true, appUpdates: true, marketing: false });
  const [validate, setValidate] = useState("0");
  const [filesResume, setFilePdf] = useState("") 
  const [file, setFile] = useState(null);

  // ── live data fetched from the DB (GET only) ──
  const [jobs, setJobs] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [dataLst, setDataTmp] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loaded, setLoaded] = useState(false);
  // Logged-in user (set at sign-in); null when browsing as a guest.
  const sessionUser = (() => {
    try { return (JSON.parse(sessionStorage.getItem("userCollection")) || [])[0] || null; }
    catch (e) { return null; }
  })();
  const userId = sessionUser ? sessionUser.userid : null;
  const loggedIn = !!userId;
  const isEmployer = !!sessionUser && (sessionUser.isEmployer === "1" || sessionUser.isEmployer === 1);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  
  const [isshow, setisshow] = useState(false)
  const [color, setcolor] = useState("")
  const [message, setmessage] = useState("")
  const [fade, setfade] = useState(false)
  const [alerttype, setalerttype] = useState("")

  // the shared NavBar drives views via ?view=… so its links work from any page
  useEffect(() => {
    const v = searchParams.get("view");
    if (v) {
      setView(v);
      if (v === "companies" || v === "jobs") setSelectedCompany(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const setAd = (k, v) => setApplyData((s) => ({ ...s, [k]: v }));
  const setDraft = (k, v) => setAlertDraft((s) => ({ ...s, [k]: v }));
  const stop = (e) => e.stopPropagation();

  // ── map raw DB records into the shapes the design's views expect ──
  const mapJob = (itm, coByCode) => {
    const co = coByCode[itm.companyId] || {};
    const company = itm.companyName || co.companyName || "Company";
    const lo = peso(itm.salaryCurrency, itm.salaryMin);
    const hi = peso(itm.salaryCurrency, itm.salaryMax);
    const exp = [itm.experienceMin, itm.experienceMax].filter((x) => x != null && x !== "").join("–");
    // Numeric fields used only for filtering/sorting (display is unchanged):
    const salNum = Math.max(num(itm.salaryMin) || 0, num(itm.salaryMax) || 0) || null;
    const postedMs = itm.createdDate ? Date.parse(itm.createdDate) : NaN;
    return {
      id: itm.id || itm.postingId, title: itm.title || "Untitled role",
      company, companyId: itm.companyId, ...brandOf(company),
      location: (co.city ? titleCase(co.city) : itm.workLocation || itm.location) || "—",
      type: itm.workType || "Full-time",
      salary: lo && hi ? lo + " – " + hi : lo || hi || "Salary undisclosed",
      posted: postedLabel(itm.createdDate), easyApply: true,
      experience: exp ? exp + " years" : "",
      description: itm.description || itm.jobPostingNote || "",
      responsibilities: itm.responsibility,
      qualifications: itm.skillsExperience,
      benefits: toList(itm.benefits),
      salNum, postedAt: isNaN(postedMs) ? null : postedMs,
      expMin: num(itm.experienceMin), expMax: num(itm.experienceMax),
    };
  };
  const mapCompany = (itm, jobsArr) => {
    const name = itm.companyName || "Company";
    return {
      name, companyCode: itm.companyCode, ...brandOf(name),
      industry: itm.industry || "—",
      hq: [itm.city, itm.country].filter(Boolean).map(titleCase).join(", ") || "—",
      size: itm.size || "", founded: itm.founded || "—", website: itm.website || "—",
      about: itm.about || itm.description || name + " is hiring on JobSpace — follow to get notified about new roles.",
      tagline: itm.tagline || name,
      openings: jobsArr.filter((j) => j.companyId === itm.companyCode || j.company === name).length,
    };
  };
  const mapProfile = (p) => {
    const v = (x) => (x == null ? "" : String(x));
    return {
      firstName: v(p.FirstName), middleName: v(p.MiddleName), lastName: v(p.LastName),
      email: v(p.EmailAddress), phone: v(p.MobileNumber || p.HomePhoneNumber),
      birthdate: v(p.DateOfBirth), gender: v(p.Gender), civil: v(p.CivilStatus),
      nationality: v(p.Nationality || p.NationalityId), headline: v(p.Title),
      address: v(p.PresentAddress || p.Address),
      skills: v(p.SpecialSkills), languages: v(p.LanguageSpoken),
      emergencyName: v(p.EmergencyContactName), emergencyPhone: v(p.EmergencyContactNumber),
    };
  };
  // Shape a raw Notifications row into the design's notification card. Field
  // names are defensive since the table may not exist yet (placeholder read).
  const mapNotification = (n) => {
    const company = n.company || n.companyName || n.sender || "JobSpace";
    const b = brandOf(company);
    return {
      id: n.id || n.postingId || n.notificationId || Math.random().toString(36).slice(2),
      company, initial: b.initial, bg: b.logoBg, color: b.logoColor,
      tag: n.tag || n.type || n.category || "Update",
      time: n.time || n.createdDate || n.timestamp || "",
      unread: n.isRead === "1" || n.read === true ? false : true,
      title: n.title || n.subject || "Notification",
      message: n.message || n.body || n.description || "",
      cta: n.cta || n.action || "View",
    };
  };

  // ── fetch public data (jobs + companies) once on mount ──
  useEffect(() => {
    const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
    if (isValidate === null){
      setValidate("0")
    }
    else {
      if(isValidate[0].isEmployer === "1"){
        setValidate("1")
      }
      else {
        setValidate("0")
      }
    }

    let alive = true;
    (async () => {
      const [rawJobs, rawCos] = await Promise.all([
        getCollection("JobPosting", {}),
        getCollection("CompanyProfile", { isDeleted: "0" }),
      ]);
      if (!alive) return;
      const coByCode = {};
      rawCos.forEach((c) => { if (c && c.userId) coByCode[c.userId] = c; });
      const mappedJobs = rawJobs
      .filter((j) => j && (j.isDeleted === "0") && j.isClosed !== "1")
      .map((j) => mapJob(j, coByCode));

      console.log("mappedJobs", mappedJobs) 
      setJobs(mappedJobs);
      setCompanyList(rawCos.map((c) => mapCompany(c, mappedJobs)));
      setDataTmp(rawCos)
      setLoaded(true);

    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── fetch the logged-in candidate's profile (+ notifications placeholder) ──
  useEffect(() => {
    if (!userId) return;
    let alive = true;
    (async () => {
      const [rawProfile, rawNotifs] = await Promise.all([
        getCollection("CandidatesProfile", { UserId: userId, isDeleted: "0" }),
        // Placeholder read for a notifications table — if the collection
        // doesn't exist, getCollection resolves to [] so the page stays empty.
        getCollection("Notifications", { userId: userId, isDeleted: "0" }),
      ]);
      if (!alive) return;
      if (rawProfile[0]) setForm((f) => ({ ...BLANK_FORM, ...mapProfile(rawProfile[0]) }));
      setNotifications(rawNotifs.map(mapNotification));
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // ── derived: jobs ──
  const q = query.trim().toLowerCase();
  const loc = location.trim().toLowerCase();
  const filteredJobs = jobs.filter((j) => {
    if (q && !(j.title.toLowerCase().includes(q) || j.company.toLowerCase().includes(q))) return false;
    if (loc && !j.location.toLowerCase().includes(loc)) return false;
    if (activeType !== "All" && j.type !== activeType) return false;
    // Salary: keep jobs whose (max) salary meets the chosen floor
    const floor = SALARY_FLOOR[filterValues.Salary];
    if (floor != null && !(j.salNum != null && j.salNum >= floor)) return false;
    // Date posted: keep jobs created within the chosen window
    const days = DATE_DAYS[filterValues["Day(s) posted"]];
    if (days != null && !(j.postedAt != null && j.postedAt >= Date.now() - days * 864e5)) return false;
    // Experience: keep jobs whose [expMin, expMax] overlaps the chosen band
    const band = EXP_RANGE[filterValues.Experience];
    if (band) {
      if (j.expMin == null && j.expMax == null) return false;
      const jMin = j.expMin != null ? j.expMin : j.expMax;
      const jMax = j.expMax != null ? j.expMax : j.expMin;
      if (!(jMin <= band[1] && jMax >= band[0])) return false;
    }
    return true;
  });
  const sortedJobs = (() => {
    const list = filteredJobs.slice();
    if (sortBy === "Newest") list.sort((a, b) => (b.postedAt || 0) - (a.postedAt || 0));
    else if (sortBy === "Salary: high to low") list.sort((a, b) => (b.salNum || 0) - (a.salNum || 0));
    else if (sortBy === "Salary: low to high") list.sort((a, b) => (a.salNum || Infinity) - (b.salNum || Infinity));
    return list; // "Most relevant" keeps the API order
  })();
  const toggleSave = (id, e) => { if (e) e.stopPropagation(); setSavedJobs((s) => ({ ...s, [id]: !s[id] })); };
  const openCompany = (name) => { setView("company"); setSelectedCompany(name); setCompanyTab("Snapshot"); setFollowed(false); setMenuOpen(false); };

  const selJob = jobs.find((j) => j.id === selectedJob);
  const selCompany = companyList.find((c) => c.name === selectedCompany) || {};
  const companyJobs = jobs.filter((j) => j.company === selectedCompany);

  const cq = companyQuery.trim().toLowerCase();
  const companies = companyList.filter((c) => !cq || c.name.toLowerCase().includes(cq) || (c.industry || "").toLowerCase().includes(cq));

  // ── derived: logged-in identity (used by the apply flow) ──
  const displayName = "";

  const companyTabDefs = [
    { label: "Snapshot" }, { label: "Why Join Us" },
    { label: "Reviews" }, { label: "Salaries" },
    { label: "Jobs", count: selCompany.openings }, { label: "Questions" }, { label: "Interviews" },
  ];
  const companyFacts = [
    { k: "Industry", v: selCompany.industry }, { k: "Headquarters", v: selCompany.hq },
    { k: "Company size", v: selCompany.size ? selCompany.size + " employees" : "—" }, { k: "Founded", v: selCompany.founded },
    { k: "Website", v: selCompany.website },
  ];


  // ── derived: notifications ──
  const notifUnread = (n) => n.unread && !reads[n.id];
  const unreadCount = notifications.filter(notifUnread).length;
  const selNotif = notifications.find((n) => n.id === selectedNotif) || {};
  const openNotif = (n) => { setSelectedNotif(n.id); setReads((s) => ({ ...s, [n.id]: true })); };

  const settingDefs = [
    { key: "jobAlerts", label: "Job alerts", desc: "New roles matching your profile" },
    { key: "appUpdates", label: "Application updates", desc: "Status changes and recruiter messages" },
    { key: "marketing", label: "Tips & promotions", desc: "Career advice and JobSpace news" },
  ];

  // ── derived: browse ──
  const showBrowse = view === "jobs" && query.trim() === "" && location.trim() === "" && activeType === "All";
  const featuredCompanies = companyList.slice().sort((a, b) => b.openings - a.openings).slice(0, 3);

  const fraction = new Intl.NumberFormat('en-NZ', {
    // style: 'currency',
    // currency: 'NZD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,

  });
  // ── derived: apply ──
  const ad = applyData;
  const reviewRows = [
    { k: "Name", v: ad.name }, { k: "Email", v: ad.email }, { k: "Phone", v: ad.phone },
    // { k: "Resume", v: ad.resumeAttached ? (displayName ? displayName.replace(/\s+/g, "_") + "_CV.pdf" : ad.resumeAttached) : "Not attached" },
    { k: "Experience", v: ad.exp }, { k: "Work authorization", v: ad.auth },
    { k: "Expected salary", v: fraction.format(ad.salary) || "—" }, { k: "Availability", v: ad.start || "—" },
    { k: "Cover note", v: ad.note ? ad.note : "—" },
  ];
  const submitApplication = () => {

    console.log("seljobs:", selJob);
    console.log("ad:", ad);

    if(ad.name === "" || ad.email === "" || ad.phone === "" || /* ad.resumeAttached === false || */ ad.note === "" || ad.salary === "" || ad.start === ""){
      setmessage(ad.name === "" && "Name is required." || ad.email === "" && "Email is required." || ad.phone === "" && "Phone is required." || ad.resumeAttached === false && "Resume is required." || ad.note === "" && "Cover note is required." || ad.salary === "" && "Expected salary is required." || ad.start === "" && "Availability is required.")
      setisshow(true)
      setcolor("danger")
      setfade(true)
    }
    else{
      handleApplySignedIn()
    }
    // 
  };
  
  const handleApplySignedIn = async() =>{

    const dateTmp = moment(new Date()).format('LLLL').split(", ")
    const date = moment(new Date()).format('MM/DD/YYYY')
    const s1 = dateTmp[1]
    const s2 = dateTmp[2]
    const combDate = s1 + " " + s2
    // // // console.log("combDate")
    // // // console.log(combDate)

    const compCode = JSON.parse(sessionStorage.getItem("userCollection"))

    const newId = getFormattedDateTime();
    let JobLst_ = await GetJobLst(selJob.title)
    let numApply = await GetNumOfApplicants(selJob.title)
    const compLst = dataLst.filter((c) => c.companyName === JobLst_[0].companyName)
    // console.log("dataLst: ", dataLst)
    // console.log("JobLst_: ", JobLst_)
    // console.log("companyList: ", companyList)
    // console.log("compLst: ", compLst)
    // console.log("filesResume: ", filesResume)

    
    const valApplied = await ValidateSameJob(JobLst_[0].postingId)
    console.log("validate: ", valApplied)
    if(valApplied === true){
      setmessage("You already applied this job.")
      setisshow(true)
      setcolor("danger")
      setfade(true)
      return
    }
    
    const data = {

      newId: newId,
      email : ad.email,
      name : ad.name,
      contact : ad.phone,
      message : ad.note,
      jobDepartment : typeof JobLst_[0].title === "undefined" ? "" : JobLst_[0].title,
      employementType : typeof JobLst_[0].workType === "undefined" ? "" : JobLst_[0].workType,
      experience : typeof JobLst_[0].experienceMin === "undefined" ? "" : JobLst_[0].experienceMin,
      qualification : "",
      educLevel : typeof JobLst_[0].education === "undefined" ? "" : JobLst_[0].education,
      expectedSalary : typeof JobLst_[0].salaryMin === "undefined" ? "" : JobLst_[0].salaryMin,
      city : typeof compLst[0].city === "undefined" ? "" : compLst[0].city,
      industry : typeof JobLst_[0].industry === "undefined" ? "" : JobLst_[0].industry,
      level : typeof JobLst_[0].level === "undefined" ? "" : JobLst_[0].level,
      isRegister : "1",
      resume : filesResume,
      dataPrivacy : "Y",
      postingId : typeof JobLst_[0].postingId === "undefined" ? "" : JobLst_[0].postingId,
      title : typeof JobLst_[0].title === "undefined" ? "" : JobLst_[0].title,
      companyName : typeof compLst[0].companyName === "undefined" ? "" : compLst[0].companyName,
      companyCode : "",
      employeeId : compCode[0].userid,
      status : "NW",
      endDate : typeof JobLst_[0].endDate === "undefined" ? "" : JobLst_[0].endDate,
      jobDocNo : numApply,
      dateApplied : combDate,
      isResume : filesResume === "" ? "0" : "1",
      procStatus : "",
      dateHired : "",
      remarks : ad.note,
      dateStart : "",

      createdDate : date,
      createdBy : compCode[0].userid,
      isModified : "0",
      modifiedDate : date,
      modifiedby : compCode[0].userid,
      isDeleted : "0",
      IsProcess : "0",
      isPhr : "0",
      jsId : "",
      newIdPic : "",
      newIdResume : "",
    }
    console.log("data")
    console.log(data)
    
    const params = {
      "_collection" : "Candidates",
      "doc_data" : data
    }

    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/add", params )
    .then(resp =>{
      // let data = resp.data
      if(resp.data==="success"){
        // sessionStorage.setItem("successdata", JSON.stringify(data))
        // navigateSuccScreen("/SuccessScreen")
        setApplyStep(4);
      }
      else{
        // console.log("error in line# 539: ")
        // alert("error")
      }
    })
    .catch(error =>{
      console.log("error: " + error)
    })

    if(filesResume !== ""){
      uploadFile();
    }
  };
  const uploadFile = () => {
    const newId = getFormattedDateTime();
    // console.log("filesResume:", filesResume); 

    if (!filesResume) {
        alert("No file selected for upload.");
        return;
    }
    
    const fileToUpload = Array.isArray(filesResume) ? filesResume[0] : filesResume;
    // console.log("fileToUpload:", fileToUpload);
    if (!fileToUpload || !(fileToUpload instanceof File)) {
        alert("Invalid file selected for upload.");
        return;
    }
    
    const fileName = fileToUpload.name;
    // console.log("File name:", fileName);
    // console.log("Type of fileName:", typeof fileName); 
    
    if (typeof fileName !== 'string') {
        alert("File name is not a valid string.");
        return;
    }

    
    const fileNameParts = fileName.split('.');
    const fileExtension = fileNameParts.pop();
    const fileNameWithoutExtension = fileNameParts.join('.'); 

    const uniqueFileName = `${fileNameWithoutExtension}-${newId}.${fileExtension}`;
    
    const S3_BUCKET = 'job-space-bucket-noser-cdr';
    const REGION = 'us-east-1';
    // const ACCESS_KEY = 'AKIA5HRIKSE2C7YD2NXQ';
    // const SECRET_KEY = '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';

    AWS.config.update({
        accessKeyId: AppConfiguration.Setting().accessKeyId,
        secretAccessKey: AppConfiguration.Setting().secretAccessKey,
        region: REGION,
    });

    const s3 = new AWS.S3();
    const params = {
        Bucket: S3_BUCKET,
        Key: uniqueFileName,
        Body: fileToUpload,
        ACL: 'bucket-owner-full-control',
    };

    // console.log("params:", params);
    s3.upload(params, (err, data) => {
        if (err) {
            // console.log("Error uploading file:", err);
            alert("Error uploading file.");
        } else {
            console.log("Successfully uploaded file:", data);
            // setFilePdf("");
            // setFiles(null);
        }
    });
  };
  const GetJobLst = async(title) => {

    let tempArr = []
    try {
      let resp = await GetRequest({
        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {
          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : {"isDeleted": "0", "title": title},
        }
      })

      // console.log("resp: ", resp.jobPosting.filter((x) => x.title === selJob.title));
      if (resp.status!=="1") {
        throw new Error("Network response was not ok");
      }
      tempArr = resp.JobPosting;

    } catch (error) {
      console.error("Error fetching job posting:", error);
    }
    return tempArr
  };
  const GetNumOfApplicants = async(title) => {
    let filter_data = {"title" : title}
    const _dataTmp = []
    const Params = {
      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "Candidates",
      "filter_data" : filter_data
    }
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {
      let data = res.data
      data.Candidates.map(function(itm,i){
        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        _dataTmp.push(json)
      })
    })
    .catch(err => {
      console.log("error: " + err)
    })
    return String(parseFloat(_dataTmp.length));
  };
  const GetCompProf = async() => {

    const dataTmp = []
    const Params = {
      "_collection" : "CompanyProfile",
      "filter_data" : {"isDeleted": "0"}
    }
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {
      let data = res.data.CompanyProfile;  
      data.map(function(itm,i){
        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        dataTmp.push(json)
      })   
    })
    console.log("dataTmp: ", dataTmp)
    return dataTmp
  };   
  const ValidateSameJob = async(jobId) =>{
    // console.log("postingId: ", jobId)

    const _dataTmp = []
    const Params = {
      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "Candidates",
      "filter_data" : {"isDeleted" : "0", "postingId": jobId}
    }
    // console.log(" Params: ", Params)
    await axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {
      let data = res.data
      data.Candidates.map(function(itm,i){
        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        _dataTmp.push(json)
      })
      // // console.log("postingId")
      // // console.log(postingId)
    })
    
    // console.log(" datalst: ", _dataTmp.filter(x=>x.postingId === jobId))

    return _dataTmp.length > 0 ? true : false
  };
  
  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };

  const openApply = async() => {

    // console.log("filteredJobs:", filteredJobs);
    await GetJobPosting();
  };

  const GetJobPosting = async() => {

    try {

      let tempArr = []
      let resp = await GetRequest({
        url : AppConfiguration.Setting().jobspaceapi + "action/get",
        params : {
          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : {"isDeleted": "0", "title": selJob.title},
        }
      })

      // console.log("resp: ", resp.jobPosting.filter((x) => x.title === selJob.title));
      if (resp.status!=="1") {
        throw new Error("Network response was not ok");
      }
      // const jobPosting = await resp.json();
      // console.log("Fetched job posting:", resp.JobPosting);
      // console.log("Fetched Company:", selJob);
      
      sessionStorage.setItem("key", JSON.stringify(resp.JobPosting[0].postingId))
      sessionStorage.setItem("companyId", JSON.stringify(selJob.companyId))

      if (!loggedIn) { navigate("/ApplicationPage"); return; }
      setApplyData((s) => ({ ...s, name: "" + "" + "", email: "", phone: "" }));
      setApplyStep(1);
      setApplyOpen(true);

    } catch (error) {
      console.error("Error fetching job posting:", error);
    }
  };

  const NavigateJobDetails = async(itms) => {
    console.log("itms")
    console.log(itms)


    // navigate("/JobDetailsDescription")
  };
  

  // ── derived: alerts ──
  const addAlert = () => { if (alertDraft.keyword.trim()) { setAlerts((s) => [...s, { id: "al" + Date.now(), keyword: alertDraft.keyword.trim(), location: alertDraft.location.trim(), freq: alertDraft.freq }]); setAlertDraft({ keyword: "", location: "", freq: "Daily" }); } };

  const filterPill = (label, active, onClick) => (
    <button onClick={onClick} style={{ padding: "8px 15px", borderRadius: 999, border: "1.5px solid " + (active ? "#009b57" : "#dde5df"), background: active ? "#009b57" : "#fff", color: active ? "#fff" : "#3c4d44", fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>{label}</button>
  );

  
      // sessionStorage.setItem("key", JSON.stringify(key.postingId))
      // navigateEmployer("/JobDescEmployer");

  const jobCard = (job) => (
    <div key={job.id} onClick={() => setSelectedJob(job.id)} className="jsa-lift2" style={{ background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 16, padding: 20, cursor: "pointer" }}>
      <div style={{ display: "flex", gap: 15 }}>
        <div style={{ flex: "none", width: 52, height: 52, borderRadius: 13, background: job.logoBg, color: job.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 21 }}>{job.initial}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
            <div style={{ minWidth: 0 }}>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, letterSpacing: "-.01em", lineHeight: 1.3 }}>{job.title}</h3>
              <div style={{ marginTop: 3, fontSize: 14, color: "#45564c", fontWeight: 600 }}>{job.company}</div>
            </div>
            <button onClick={(e) => toggleSave(job.id, e)} className="jsa-save" style={{ flex: "none", width: 34, height: 34, borderRadius: 9, border: "1.5px solid #e8ede9", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Bookmark fill={savedJobs[job.id] ? "#009b57" : "none"} />
            </button>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginTop: 13 }}>
            <span style={pill("#f1f5f2", "#4a5b51")}><Pin s={13} stroke="#6f8077" />{job.location}</span>
            <span style={pill("#f1f5f2", "#4a5b51")}>{job.type}</span>
            <span style={greenPill}>{job.salary}</span>
          </div>
            
          {validate === "0" && <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 14 }}>
            <span style={{ fontSize: 12.5, color: "#8a9a91", fontWeight: 600 }}>{job.posted}</span>
            {job.easyApply && <span /* onClick={() => NavigateJobDetails(job.id)} */ style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12.5, fontWeight: 700, color: "#009b57" }}><Bolt />Easy Apply</span>}
          </div>}
        </div>
      </div>
    </div>
  );
  
  {/* -- Resume Function -- */}
  const UploadResume = (e) => {
    setisshow(false)

    const allowedTypes = [
      "application/pdf", // pdf
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    const selectedFile = e.target.files[0];
    // const file = e.target.files[0];
    if (!selectedFile) return; // No file selected

    // Validate file type
    if (!allowedTypes.includes(selectedFile.type)) {
      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessage("Only PDF or Word documents (.doc, .docx) are allowed in resume.")
      setfade(true)
      e.target.value = ""; // Reset file input
      return;
    }

    if (selectedFile) {
      setFilePdf(selectedFile);
      setFile(selectedFile);
      // console.log("File uploaded:", selectedFile.name);
    } else {
      setFile(null);
    }
    // setApplyData("resumeAttached", !ad.resumeAttached)
    
  };

  const input = (props) => <input {...props} className="jsa-input" />;
  const onChangeSalary = async(value, name, values) =>{
    console.log(value)
    setAd("salary", value)
  };

  return (
    <div className="jsa-root" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#f4f7f4", minHeight: "100vh", color: "#16271f" }}>

      {/* ── HEADER: now the single shared NavBar ── */}
      <NavBar />
      <div style={{ height: 68 }} />

      {menuOpen && <div onClick={() => setMenuOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 25 }} />}

      {/* ── COMPANIES VIEW ── */}
      {view === "companies" && (
        <main style={{ maxWidth: 1100, margin: "0 auto", padding: "30px 24px 80px" }}>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, letterSpacing: "-.02em" }}>Explore companies</h1>
          <p style={{ margin: "6px 0 22px", fontSize: 14.5, color: "#6c7d74", fontWeight: 500 }}>Discover top employers hiring across the Philippines.</p>
          <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: "1px solid #e2e9e3", borderRadius: 100, padding: "7px 7px 7px 18px", boxShadow: "0 8px 26px rgba(20,50,38,.06)", maxWidth: 560 }}>
            <Search />
            {input({ value: companyQuery, onChange: (e) => setCompanyQuery(e.target.value), placeholder: "Search companies or industries", style: { border: "none", outline: "none", fontFamily: "inherit", fontSize: 15, fontWeight: 500, color: "#16271f", width: "100%", background: "transparent", height: 40 } })}
            <button className="jsa-primary" style={{ ...primaryBtn, flex: "none", padding: "0 24px", height: 42, fontSize: 14.5 }}>Search</button>
          </div>
          <div style={{ margin: "22px 0 16px", fontSize: 14, color: "#6c7d74", fontWeight: 600 }}>{companies.length} companies</div>
          {companies.length > 0 ? (
            <div className="jsa-grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
              {companies.map((c) => (
                <div key={c.name} onClick={() => openCompany(c.name)} className="jsa-lift3" style={{ background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 18, padding: 22, cursor: "pointer", display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
                    <div style={{ flex: "none", width: 56, height: 56, borderRadius: 15, background: c.logoBg, color: c.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 23 }}>{c.initial}</div>
                    <div style={{ minWidth: 0 }}>
                      <h3 style={{ margin: 0, fontSize: 16.5, fontWeight: 800, letterSpacing: "-.01em", lineHeight: 1.25 }}>{c.name}</h3>
                      <div style={{ marginTop: 3, fontSize: 12.5, color: "#7c8b82", fontWeight: 600 }}>{c.industry}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 7, marginTop: 18 }}>
                    {c.rating ? (
                      <>
                        <Star /><span style={{ fontSize: 14, fontWeight: 800, color: "#16271f" }}>{c.rating}</span>
                        <span style={{ fontSize: 12.5, color: "#8a9a91", fontWeight: 600 }}>({c.reviews} reviews)</span>
                      </>
                    ) : (
                      <span style={{ fontSize: 12.5, color: "#8a9a91", fontWeight: 600 }}>No reviews yet</span>
                    )}
                  </div>
                  <div style={{ height: 1, background: "#f0f4f1", margin: "16px 0" }} />
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "auto" }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 7, fontSize: 13.5, fontWeight: 700, color: "#047a45" }}>
                      <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#009b57" }} />{c.openings} open jobs
                    </span>
                    <Chevron dir="right" stroke="#9aa89f" s={16} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ minHeight: "42vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 0", color: "#8a9a91" }}>
              <div style={{ fontSize: 17, fontWeight: 700, color: "#45564c" }}>No companies found</div>
              <div style={{ fontSize: 14, marginTop: 6 }}>Try a different search term.</div>
            </div>
          )}
        </main>
      )}

      {/* ── COMPANY PROFILE VIEW ── */}
      {view === "company" && (
        <main style={{ maxWidth: 1000, margin: "0 auto", padding: "22px 24px 80px" }}>
          <button onClick={() => { setView("companies"); setSelectedCompany(null); }} className="jsa-ghost" style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 14px", borderRadius: 100, border: "1.5px solid #dde5df", background: "#fff", color: "#3c4d44", fontFamily: "inherit", fontSize: 13.5, fontWeight: 700, cursor: "pointer", marginBottom: 16 }}>
            <Chevron dir="left" stroke="#3c4d44" s={15} />All companies
          </button>
          <div style={{ background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 22, overflow: "hidden" }}>
            <div style={{ height: 150, background: "linear-gradient(125deg,#11271d,#0b6e40)", position: "relative" }}>
              <div style={{ position: "absolute", right: 28, top: 22, fontSize: 22, fontWeight: 800, color: "rgba(255,255,255,.85)", letterSpacing: ".04em" }}>{selCompany.tagline}</div>
            </div>
            <div style={{ padding: "0 28px 22px", display: "flex", alignItems: "flex-end", gap: 18, flexWrap: "wrap" }}>
              <div style={{ flex: "none", width: 92, height: 92, borderRadius: 20, background: selCompany.logoBg, color: selCompany.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 38, marginTop: -42, border: "4px solid #fff", boxShadow: "0 8px 22px rgba(20,50,38,.14)", zIndex: 10 }}>{selCompany.initial}</div>
              <div style={{ flex: 1, minWidth: 200, paddingTop: 14 }}>
                <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, letterSpacing: "-.02em" }}>{selCompany.name}</h1>
                <div style={{ display: "flex", alignItems: "center", gap: 7, marginTop: 6 }}>
                  {selCompany.rating && <><Star /><span style={{ fontSize: 14.5, fontWeight: 800 }}>{selCompany.rating}</span></>}
                  <span style={{ fontSize: 13, color: "#8a9a91", fontWeight: 600 }}>{[selCompany.industry, selCompany.hq].filter((x) => x && x !== "—").join(" · ")}</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, paddingTop: 14 }}>
                <button onClick={() => setFollowed((v) => !v)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "11px 22px", borderRadius: 100, border: "none", background: followed ? "#ecf7f0" : "#009b57", color: followed ? "#047a45" : "#fff", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 12px rgba(0,154,87,.22)" }}>{followed ? "✓ Following" : "Follow"}</button>
                <button className="jsa-ghost" style={{ padding: "11px 20px", borderRadius: 100, border: "1.5px solid #dde5df", background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Write a review</button>
              </div>
            </div>
            <div style={{ display: "flex", gap: 4, padding: "0 20px", borderTop: "1px solid #eef2ee", overflowX: "auto" }}>
              {companyTabDefs.map((t) => {
                const active = t.label === companyTab;
                return (
                  <button key={t.label} onClick={() => setCompanyTab(t.label)} style={{ flex: "none", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: 3, padding: "12px 16px", minHeight: 54, border: "none", background: "transparent", borderBottom: "3px solid " + (active ? "#009b57" : "transparent"), fontFamily: "inherit", cursor: "pointer" }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "#8a9a91", lineHeight: 1 }}>{t.count != null ? t.count : " "}</span>
                    <span style={{ fontSize: 14, fontWeight: active ? 800 : 600, color: active ? "#047a45" : "#3c4d44", whiteSpace: "nowrap", lineHeight: 1 }}>{t.label}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* SNAPSHOT */}
          {companyTab === "Snapshot" && (
            <>
              <div className="jsa-grid-2col" style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 16, marginTop: 18 }}>
                <div style={card}>
                  <h2 style={{ margin: "0 0 12px", fontSize: 17, fontWeight: 800 }}>About {selCompany.name}</h2>
                  <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.65, color: "#3c4d44" }}>{selCompany.about}</p>
                </div>
                <div style={card}>
                  <h2 style={{ margin: "0 0 14px", fontSize: 17, fontWeight: 800 }}>Company details</h2>
                  <div style={{ display: "flex", flexDirection: "column", gap: 13 }}>
                    {companyFacts.map((ft) => (
                      <div key={ft.k} style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                        <span style={{ fontSize: 13.5, color: "#8a9a91", fontWeight: 600 }}>{ft.k}</span>
                        <span style={{ fontSize: 13.5, color: "#16271f", fontWeight: 700, textAlign: "right" }}>{ft.v}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{ ...card, marginTop: 16 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                  <h2 style={sectionTitle}>Open positions</h2>
                  <button onClick={() => setCompanyTab("Jobs")} style={{ fontSize: 13.5, fontWeight: 700, color: "#009b57", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit" }}>See all {selCompany.openings} jobs →</button>
                </div>
                {companyJobs.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
                    {companyJobs.slice(0, 3).map((job) => (
                      <div key={job.id} onClick={() => setSelectedJob(job.id)} className="jsa-rowlink" style={{ display: "flex", alignItems: "center", gap: 14, border: "1.5px solid #e8ede9", borderRadius: 14, padding: "15px 17px", cursor: "pointer" }}>
                        <div style={{ flex: "none", width: 44, height: 44, borderRadius: 11, background: job.logoBg, color: job.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 17 }}>{job.initial}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-.01em" }}>{job.title}</div>
                          <div style={{ fontSize: 13, color: "#6c7d74", fontWeight: 600, marginTop: 2 }}>{job.location} · {job.type}</div>
                        </div>
                        <span style={{ flex: "none", fontSize: 13, fontWeight: 700, color: "#047a45" }}>{job.salary}</span>
                      </div>
                    ))}
                  </div>
                ) : <p style={{ margin: 0, fontSize: 14, color: "#8a9a91" }}>No live listings right now — follow {selCompany.name} to get notified.</p>}
              </div>
            </>
          )}

          {/* JOBS */}
          {companyTab === "Jobs" && (
            <>
              <h2 style={{ margin: "24px 0 14px", fontSize: 19, fontWeight: 800, letterSpacing: "-.01em" }}>{selCompany.openings} jobs at {selCompany.name}</h2>
              {companyJobs.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>{companyJobs.map(jobCard)}</div>
              ) : (
                <div style={{ minHeight: "30vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", color: "#8a9a91", padding: "30px 0" }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#45564c" }}>No live listings right now</div>
                  <div style={{ fontSize: 14, marginTop: 6 }}>Follow {selCompany.name} to get notified when they post.</div>
                </div>
              )}
            </>
          )}

          {/* WHY JOIN US */}
          {companyTab === "Why Join Us" && (
            <div style={{ ...card, marginTop: 18 }}>
              <h2 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 800 }}>Why join {selCompany.name}</h2>
              <p style={{ margin: "0 0 18px", fontSize: 14.5, lineHeight: 1.65, color: "#3c4d44" }}>{selCompany.about}</p>
              <h3 style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Benefits &amp; perks</h3>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 9 }}>
                {COMPANY_PERKS.map((p) => (
                  <span key={p} style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 14px", borderRadius: 100, background: "#ecf7f0", color: "#047a45", fontSize: 13, fontWeight: 700 }}><Check stroke="#047a45" s={14} />{p}</span>
                ))}
              </div>
            </div>
          )}

          {/* REVIEWS — no review collection in the DB yet */}
          {companyTab === "Reviews" && (
            <div style={{ ...card, padding: 40, marginTop: 18, textAlign: "center" }}>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>No reviews yet for {selCompany.name}</h2>
              <p style={{ margin: "8px 0 20px", fontSize: 14.5, color: "#6c7d74", fontWeight: 500 }}>Be the first to share what it's like to work here.</p>
              <button className="jsa-primary" style={{ ...primaryBtn, padding: "11px 22px", fontSize: 14 }}>Write a review</button>
            </div>
          )}

          {/* SALARIES — no salary collection in the DB yet */}
          {companyTab === "Salaries" && (
            <div style={{ ...card, padding: 40, marginTop: 18, textAlign: "center" }}>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>No salary data yet for {selCompany.name}</h2>
              <p style={{ margin: "8px 0 0", fontSize: 14.5, color: "#6c7d74", fontWeight: 500 }}>Salaries reported by employees will appear here.</p>
            </div>
          )}

          {/* QUESTIONS / INTERVIEWS */}
          {companyTab === "Questions" && (
            <div style={{ ...card, padding: 40, marginTop: 18, textAlign: "center" }}>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>Questions about working at {selCompany.name}?</h2>
              <p style={{ margin: "8px 0 20px", fontSize: 14.5, color: "#6c7d74", fontWeight: 500 }}>Get answers from people who actually work there.</p>
              <button className="jsa-primary" style={{ ...primaryBtn, padding: "11px 22px", fontSize: 14 }}>Ask a question</button>
            </div>
          )}
          {companyTab === "Interviews" && (
            <div style={{ ...card, padding: 40, marginTop: 18, textAlign: "center" }}>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800 }}>Interviews at {selCompany.name}</h2>
              <p style={{ margin: "8px 0 20px", fontSize: 14.5, color: "#6c7d74", fontWeight: 500 }}>Share your interview experience to help other jobseekers.</p>
              <button className="jsa-primary" style={{ ...primaryBtn, padding: "11px 22px", fontSize: 14 }}>Share your experience</button>
            </div>
          )}
        </main>
      )}

      {/* ── JOBS VIEW ── */}
      {view === "jobs" && (
        <div>
          <div style={{ position: "sticky", top: 68, zIndex: 20, background: "#f4f7f4", padding: "18px 24px 14px", borderBottom: "1px solid #eaefea" }}>
            <div style={{ maxWidth: 1160, margin: "0 auto" }}>
              <div style={{ display: "flex", gap: 10, alignItems: "stretch", background: "#fff", border: "1px solid #e2e9e3", borderRadius: 100, padding: 8, boxShadow: "0 8px 26px rgba(20,50,38,.06)" }}>
                <div style={{ flex: 1.4, display: "flex", alignItems: "center", gap: 10, padding: "0 14px", borderRight: "1px solid #eef2ee" }}>
                  <Search />
                  {input({ value: query, onChange: (e) => setQuery(e.target.value), placeholder: "Job title, keyword, or company", style: { border: "none", outline: "none", fontFamily: "inherit", fontSize: 15, fontWeight: 500, color: "#16271f", width: "100%", background: "transparent", height: 44 } })}
                </div>
                <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 10, padding: "0 14px" }}>
                  <Pin s={19} />
                  {input({ value: location, onChange: (e) => setLocation(e.target.value), placeholder: "City or region", style: { border: "none", outline: "none", fontFamily: "inherit", fontSize: 15, fontWeight: 500, color: "#16271f", width: "100%", background: "transparent", height: 44 } })}
                </div>
                <button className="jsa-primary" style={{ ...primaryBtn, flex: "none", padding: "0 26px", fontSize: 15, boxShadow: "0 4px 12px rgba(0,154,87,.28)" }}>Search</button>
              </div>
              <div style={{ display: "flex", gap: 9, marginTop: 13, flexWrap: "wrap", alignItems: "center" }}>
                {["All", "Full-time", "Contract", "Remote (PH)"].map((t) => filterPill(t === "Remote (PH)" ? "Remote" : t, activeType === t, () => setActiveType(t)))}
                <div style={{ width: 1, height: 22, background: "#dde5df", margin: "0 4px" }} />
                {Object.keys(FILTER_CONFIG).map((name) => {
                  const current = filterValues[name];
                  const isDefault = current === FILTER_CONFIG[name][0];
                  const open = openFilter === name;
                  const active = open || !isDefault;
                  return (
                    <div key={name} style={{ position: "relative" }}>
                      <button onClick={() => setOpenFilter((o) => (o === name ? null : name))} style={{ padding: "8px 15px", borderRadius: 999, border: "1.5px solid " + (active ? "#bfe4d0" : "#dde5df"), background: active ? "#ecf7f0" : "#fff", color: active ? "#047a45" : "#3c4d44", fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 7 }}>{isDefault ? name : current} <Chevron s={11} stroke={active ? "#009b57" : "#7c8b82"} /></button>
                      {open && (
                        <div style={{ position: "absolute", top: "calc(100% + 9px)", left: 0, zIndex: 40, background: "#fff", border: "1px solid #e2e9e3", borderRadius: 15, boxShadow: "0 14px 38px rgba(20,50,38,.16)", padding: 7, minWidth: 210 }}>
                          {FILTER_CONFIG[name].map((value) => (
                            <button key={value} onClick={() => { setFilterValues((s) => ({ ...s, [name]: value })); setOpenFilter(null); }} className="jsa-menuitem" style={{ display: "flex", width: "100%", textAlign: "left", alignItems: "center", justifyContent: "space-between", gap: 9, padding: "9px 12px", border: "none", background: current === value ? "#f3faf6" : "#fff", borderRadius: 10, fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, color: current === value ? "#047a45" : "#3c4d44", cursor: "pointer" }}>{value}{current === value && <Check stroke="#009b57" s={15} />}</button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {openFilter !== null && <div onClick={() => setOpenFilter(null)} style={{ position: "fixed", inset: 0, zIndex: 35 }} />}
            </div>
          </div>

          <main style={{ maxWidth: 760, margin: "0 auto", padding: "26px 24px 80px" }}>
            {/* {showBrowse && (
              <div style={{ marginBottom: 28 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                  <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, letterSpacing: "-.01em" }}>Browse by category</h2>
                  <button onClick={() => { setAlertsOpen(true); setMenuOpen(false); }} className="jsa-soft" style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "8px 15px", borderRadius: 100, border: "1.5px solid #bfe4d0", background: "#ecf7f0", color: "#047a45", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer" }}><Bell s={14} stroke="#047a45" />Create job alert</button>
                </div>
                <div className="jsa-grid-4" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
                  {CAT_DEFS.map((cat) => (
                    <button key={cat.name} onClick={() => { setView("jobs"); setQuery(cat.q); setMenuOpen(false); }} className="jsa-lift2b" style={{ display: "flex", flexDirection: "column", gap: 8, padding: 15, borderRadius: 14, border: "1.5px solid #e8ede9", background: "#fff", cursor: "pointer", textAlign: "left" }}>
                      <div style={{ width: 36, height: 36, borderRadius: 10, background: cat.bg, color: cat.color, display: "flex", alignItems: "center", justifyContent: "center" }}>{cat.icon}</div>
                      <div>
                        <div style={{ fontSize: 13.5, fontWeight: 700, color: "#16271f", lineHeight: 1.2 }}>{cat.name}</div>
                        <div style={{ fontSize: 12, color: "#8a9a91", fontWeight: 600, marginTop: 2 }}>{jobs.filter((j) => (j.title + " " + j.company).toLowerCase().includes(cat.q.toLowerCase())).length} jobs</div>
                      </div>
                    </button>
                  ))}
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "28px 0 14px" }}>
                  <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, letterSpacing: "-.01em" }}>Featured companies</h2>
                  <button onClick={() => { setView("companies"); setSelectedCompany(null); }} style={{ fontSize: 13, fontWeight: 700, color: "#009b57", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit" }}>View all →</button>
                </div>
                <div className="jsa-grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
                  {featuredCompanies.map((fc) => (
                    <button key={fc.name} onClick={() => openCompany(fc.name)} className="jsa-lift2b" style={{ display: "flex", alignItems: "center", gap: 12, padding: 14, borderRadius: 14, border: "1.5px solid #e8ede9", background: "#fff", cursor: "pointer", textAlign: "left" }}>
                      <div style={{ flex: "none", width: 42, height: 42, borderRadius: 11, background: fc.logoBg, color: fc.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 17 }}>{fc.initial}</div>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 700, color: "#16271f", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{fc.name}</div>
                        <div style={{ fontSize: 12, color: "#047a45", fontWeight: 700, marginTop: 2 }}>{fc.openings} open jobs</div>
                      </div>
                    </button>
                  ))}
                </div>
                <div style={{ height: 1, background: "#eaefea", margin: "28px 0 0" }} />
              </div>
            )} */}
            <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", marginBottom: 18 }}>
              <div>
                <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, letterSpacing: "-.02em" }}>{filteredJobs.length} jobs found</h1>
                <p style={{ margin: "4px 0 0", fontSize: 14, color: "#6c7d74", fontWeight: 500 }}>{q || loc ? "Filtered by your search" : "Based on roles popular in the Philippines"}</p>
              </div>
              <div style={{ position: "relative" }}>
                <button onClick={() =>  setSortOpen((v) => !v)} style={{ display: "flex", alignItems: "center", gap: 7, padding: "8px 14px", borderRadius: 10, border: "1.5px solid " + (sortOpen ? "#bfe4d0" : "#dde5df"), background: sortOpen ? "#ecf7f0" : "#fff", color: sortOpen ? "#047a45" : "#3c4d44", fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, cursor: "pointer" }}>{sortBy} <Chevron s={11} stroke={sortOpen ? "#009b57" : "#7c8b82"} /></button>
                {sortOpen && (
                  <div style={{ position: "absolute", top: "calc(100% + 9px)", right: 0, zIndex: 40, background: "#fff", border: "1px solid #e2e9e3", borderRadius: 15, boxShadow: "0 14px 38px rgba(20,50,38,.16)", padding: 7, minWidth: 210 }}>
                    {SORT_OPTIONS.map((opt) => (
                      <button key={opt} onClick={() => { setSortBy(opt); setSortOpen(false); }} className="jsa-menuitem" style={{ display: "flex", width: "100%", textAlign: "left", alignItems: "center", justifyContent: "space-between", gap: 9, padding: "9px 12px", border: "none", background: sortBy === opt ? "#f3faf6" : "#fff", borderRadius: 10, fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, color: sortBy === opt ? "#047a45" : "#3c4d44", cursor: "pointer" }}>{opt}{sortBy === opt && <Check stroke="#009b57" s={15} />}</button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {sortOpen && <div onClick={() => setSortOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 35 }} />}
            {!loaded ? (
              <div style={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#8a9a91", fontSize: 14.5, fontWeight: 600 }}>Loading jobs…</div>
            ) : filteredJobs.length === 0 ? (
              <div style={{ minHeight: "46vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 0" }}>
                <div style={{ width: 78, height: 78, borderRadius: "50%", background: "#ecf2ee", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}><Search s={34} stroke="#9aab9f" /></div>
                <h3 style={{ margin: 0, fontSize: 19, fontWeight: 800, letterSpacing: "-.01em", color: "#16271f" }}>{jobs.length === 0 ? "No jobs posted yet" : "No jobs match your filters"}</h3>
                <p style={{ margin: "8px 0 22px", fontSize: 14.5, color: "#6c7d74", fontWeight: 500, maxWidth: 360, lineHeight: 1.55 }}>{jobs.length === 0 ? "Check back soon — new roles are posted regularly." : "Try adjusting your keywords or clearing some filters to see more roles."}</p>
                {jobs.length > 0 && <button onClick={() => { setQuery(""); setLocation(""); setActiveType("All"); setOpenFilter(null); setFilterValues({ Salary: "Any salary", "Day(s) posted": "All", Experience: "Any experience" }); }} className="jsa-primary" style={{ ...primaryBtn, padding: "11px 22px", fontSize: 14, boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>Clear all filters</button>}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>{filteredJobs.sort((a, b) => a.id < b.id ? 1 : -1 ).map(jobCard)}</div>
            )}
          </main>
        </div>
      )}

      {/* ── NOTIFICATIONS VIEW ── */}
      {view === "notifications" && (
        <main style={{ maxWidth: 760, margin: "0 auto", padding: "28px 24px 80px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
            <div>
              <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, letterSpacing: "-.02em" }}>Notifications</h1>
              <p style={{ margin: "5px 0 0", fontSize: 14, color: "#6c7d74", fontWeight: 500 }}>{unreadCount > 0 ? "You have " + unreadCount + " unread notifications" : "You're all caught up"}</p>
            </div>
            {notifications.length > 0 && <button onClick={() => { const r = {}; notifications.forEach((n) => (r[n.id] = true)); setReads(r); }} className="jsa-ghost" style={{ padding: "9px 16px", borderRadius: 100, border: "1.5px solid #dde5df", background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 13.5, fontWeight: 700, cursor: "pointer" }}>Mark all as read</button>}
          </div>
          {notifications.length === 0 ? (
            <div style={{ minHeight: "42vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 0" }}>
              <div style={{ width: 78, height: 78, borderRadius: "50%", background: "#ecf2ee", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}><Bell s={34} stroke="#9aab9f" /></div>
              <h3 style={{ margin: 0, fontSize: 19, fontWeight: 800, letterSpacing: "-.01em", color: "#16271f" }}>You're all caught up</h3>
              <p style={{ margin: "8px 0 0", fontSize: 14.5, color: "#6c7d74", fontWeight: 500, maxWidth: 340, lineHeight: 1.55 }}>No notifications yet. Updates about your applications and messages will show up here.</p>
            </div>
          ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
            {notifications.map((n) => {
              const unread = notifUnread(n);
              return (
                <div key={n.id} onClick={() => openNotif(n)} className="jsa-notifcard" style={{ display: "flex", gap: 15, background: unread ? "#fff" : "#fbfdfc", border: "1.5px solid " + (unread ? "#d4ecdd" : "#e8ede9"), borderRadius: 16, padding: 18, cursor: "pointer" }}>
                  <div style={{ flex: "none", width: 48, height: 48, borderRadius: 12, background: n.bg, color: n.color, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 19 }}>{n.initial}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: n.color, padding: "3px 9px", borderRadius: 999, background: n.bg }}>{n.tag}</span>
                      <span style={{ fontSize: 12.5, color: "#9aa89f", fontWeight: 600 }}>{n.time}</span>
                      {unread && <span style={{ marginLeft: "auto", width: 9, height: 9, borderRadius: "50%", background: "#009b57" }} />}
                    </div>
                    <h3 style={{ margin: "9px 0 4px", fontSize: 15.5, fontWeight: unread ? 800 : 700, letterSpacing: "-.01em", lineHeight: 1.3 }}>{n.title}</h3>
                    <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: "#5b6b63", overflow: "hidden", textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{n.message}</p>
                  </div>
                </div>
              );
            })}
          </div>
          )}
        </main>
      )}


      {/* ── SETTINGS VIEW ── */}
      {view === "settings" && (
        <main style={{ maxWidth: 640, margin: "0 auto", padding: "28px 24px 80px" }}>
          <h1 style={{ margin: "0 0 20px", fontSize: 24, fontWeight: 800, letterSpacing: "-.02em" }}>Settings</h1>
          <div style={{ background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 20, padding: 26 }}>
            <h2 style={{ margin: "0 0 18px", fontSize: 16, fontWeight: 800 }}>Email notifications</h2>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {settingDefs.map((d) => {
                const on = settings[d.key];
                return (
                  <div key={d.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 0", borderBottom: "1px solid #f0f4f1" }}>
                    <div style={{ minWidth: 0, paddingRight: 16 }}>
                      <div style={{ fontSize: 14.5, fontWeight: 700 }}>{d.label}</div>
                      <div style={{ fontSize: 13, color: "#7c8b82", fontWeight: 500, marginTop: 2 }}>{d.desc}</div>
                    </div>
                    <button onClick={() => setSettings((s) => ({ ...s, [d.key]: !s[d.key] }))} style={{ flex: "none", width: 46, height: 27, borderRadius: 999, border: "none", cursor: "pointer", background: on ? "#009b57" : "#d3ddd6", position: "relative", transition: "background .15s" }}>
                      <span style={{ position: "absolute", top: 3, left: on ? 22 : 3, width: 21, height: 21, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,.2)", transition: "left .15s" }} />
                    </button>
                  </div>
                );
              })}
            </div>
            <button className="jsa-primary" style={{ ...primaryBtn, marginTop: 22, padding: "12px 22px", fontSize: 14, boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>Save changes</button>
          </div>
        </main>
      )}

      {/* ── FOOTER ── */}
      <footer style={{ background: "#11271d", color: "#c9d6cd", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ maxWidth: 1160, margin: "0 auto", padding: "52px 24px 28px" }}>
          <div className="jsa-foot-grid" style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1fr 1fr", gap: 40 }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                <JobSpaceLogo variant="icon" height={30} />
                <span style={{ fontWeight: 800, fontSize: 20, letterSpacing: "-.02em", color: "#fff" }}>JobSpace</span>
              </div>
              <p style={{ margin: "16px 0 0", fontSize: 13.5, lineHeight: 1.65, color: "#8fa698", maxWidth: 280 }}>The Philippines' modern job board — connecting Filipino talent with the country's best employers.</p>
              <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
                {[
                  <path d="M13 22v-8h2.7l.4-3H13V9c0-.9.3-1.5 1.6-1.5H16V4.8c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1V11H7v3h2.6v8H13Z" />,
                  <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM8.3 18H5.7V9.7h2.6V18Zm-1.3-9.4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM18.3 18h-2.6v-4.4c0-1-.4-1.7-1.3-1.7-.7 0-1.1.5-1.3 1-.1.2-.1.5-.1.7V18h-2.6V9.7h2.6v1.1c.3-.5 1-1.3 2.4-1.3 1.7 0 3 1.1 3 3.6V18Z" />,
                ].map((p, i) => (
                  <a key={i} className="jsa-social" style={{ width: 36, height: 36, borderRadius: 10, background: "#1d3a2c", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}><Ic s={17} fill="#9fb6a7">{p}</Ic></a>
                ))}
                <a className="jsa-social" style={{ width: 36, height: 36, borderRadius: 10, background: "#1d3a2c", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}><Ic s={17}><rect x="3.5" y="3.5" width="17" height="17" rx="5" stroke="#9fb6a7" strokeWidth="1.8" /><circle cx="12" cy="12" r="3.6" stroke="#9fb6a7" strokeWidth="1.8" /><circle cx="17" cy="7" r="1.2" fill="#9fb6a7" /></Ic></a>
              </div>
            </div>
            {[
              // { h: "For Jobseekers", links: [["Browse Jobs", () => setView("jobs")], ["Companies", () => { setView("companies"); setSelectedCompany(null); }], ["Salary Guide", null], ["Career Advice", null]] },
              // { h: "For Employers", links: [["Post a Job", null], ["Pricing", null], ["Search Resumes", null], ["Hiring Solutions", null]] },
              { h: "Company", links: [["About Us", null], ["Contact", null], ["Privacy Policy", null], ] },
              // ["Terms of Service", null]]
            ].map((col) => (
              <div key={col.h}>
                <h5 style={{ margin: "0 0 16px", fontSize: 13, fontWeight: 700, color: "#fff", letterSpacing: ".02em" }}>{col.h}</h5>
                <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
                  {col.links.map(([label, onClick]) => (
                    <a key={label} onClick={onClick || undefined} className="jsa-flink" style={{ fontSize: 13.5, color: "#9fb6a7", textDecoration: "none", cursor: "pointer" }}>{label}</a>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 40, paddingTop: 22, borderTop: "1px solid #1f3a2c", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <span style={{ fontSize: 13, color: "#7c9486" }}>© 2026 JobSpace Philippines. All rights reserved.</span>
            <span style={{ fontSize: 13, color: "#7c9486" }}>Pasig City, Metro Manila 🇵🇭</span>
          </div>
        </div>
      </footer>

      {/* ── JOB DETAIL MODAL ── */}
      {selJob && (
        <div onClick={() => setSelectedJob(null)} style={{ position: "fixed", inset: 0, zIndex: 50, background: "rgba(16,32,25,.5)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 20px", overflowY: "auto", animation: "jsFade .18s ease" }}>
          <div onClick={stop} style={{ width: "100%", maxWidth: 640, background: "#fff", borderRadius: 22, boxShadow: "0 30px 90px rgba(10,30,20,.4)", animation: "jsRise .26s cubic-bezier(.18,.9,.3,1.2)", overflow: "hidden" }}>
            <div style={{ padding: "26px 28px 22px", borderBottom: "1px solid #eef2ee", position: "relative" }}>
              <button onClick={() => setSelectedJob(null)} className="jsa-close" style={{ position: "absolute", top: 18, right: 18, width: 36, height: 36, borderRadius: 10, border: "none", background: "#f1f5f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Close /></button>
              <div style={{ display: "flex", gap: 16 }}>
                <div style={{ flex: "none", width: 60, height: 60, borderRadius: 15, background: selJob.logoBg, color: selJob.logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 25 }}>{selJob.initial}</div>
                <div style={{ flex: 1, minWidth: 0, paddingRight: 36 }}>
                  <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, letterSpacing: "-.02em", lineHeight: 1.25 }}>{selJob.title}</h2>
                  <div style={{ marginTop: 5, fontSize: 15, fontWeight: 700, color: "#009b57" }}>{selJob.company}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginTop: 13 }}>
                    <span style={pill("#f1f5f2", "#4a5b51")}>{selJob.location}</span>
                    <span style={pill("#f1f5f2", "#4a5b51")}>{selJob.type}</span>
                    <span style={greenPill}>{selJob.salary}</span>
                    <span style={pill("#f1f5f2", "#4a5b51")}>{selJob.experience}</span>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ padding: "24px 28px", maxHeight: "46vh", overflowY: "auto" }}>
              <h4 style={{ margin: "0 0 11px", fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Job Description</h4>
              {selJob.description && <p style={{ margin: "0 0 22px", fontSize: 14.5, lineHeight: 1.65, color: "#3c4d44" }}>{selJob.description}</p>}
              {selJob.qualifications.length > 0 && (<>
                <h4 style={{ margin: "0 0 11px", fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Skills Required</h4>
                <div style={{ display: "flex", flexDirection: "column", gap: 9, marginBottom: 22 }}>
                  {selJob.qualifications.map((qf, i) => (<div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}><CheckCircle /><span style={{ fontSize: 14, lineHeight: 1.55, color: "#3c4d44" }}>{qf.skill}</span></div>))}
                </div>
              </>)}
              {selJob.responsibilities.length > 0 && (<>
                <h4 style={{ margin: "0 0 11px", fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Job Responsibilities</h4>
                <div style={{ display: "flex", flexDirection: "column", gap: 9, marginBottom: 22 }}>
                  {selJob.responsibilities.map((r, i) => (<div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}><CheckCircle /><span style={{ fontSize: 14, lineHeight: 1.55, color: "#3c4d44" }}>{r.responsibility}</span></div>))}
                </div>
              </>)}
              {/* {selJob.benefits.length > 0 && (<>
                <h4 style={{ margin: "0 0 11px", fontSize: 13, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Benefits</h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {selJob.benefits.map((b, i) => (<span key={i} style={{ padding: "7px 13px", borderRadius: 10, background: "#f1f5f2", fontSize: 13, fontWeight: 600, color: "#45564c" }}>{b}</span>))}
                </div>
              </>)} */}
              {!selJob.description && selJob.responsibilities.length === 0 && selJob.qualifications.length === 0 && (
                <p style={{ margin: 0, fontSize: 14, color: "#8a9a91", fontWeight: 500 }}>No additional details were provided for this role. Tap Apply Now to submit your application.</p>
              )}
            </div>
            {validate === "0" && (
              <div style={{ padding: "16px 28px", borderTop: "1px solid #eef2ee", display: "flex", gap: 11, alignItems: "center", background: "#fbfdfb" }}>
                <button onClick={openApply} className="jsa-primary" style={{ flex: 1, padding: 13, border: "none", borderRadius: 12, background: "#009b57", color: "#fff", fontFamily: "inherit", fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>Apply Now</button>
                <button onClick={(e) => toggleSave(selJob.id, e)} className="jsa-save" style={{ flex: "none", padding: "13px 18px", border: "1.5px solid #dde5df", borderRadius: 12, background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 15, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}><Bookmark fill={savedJobs[selJob.id] ? "#009b57" : "none"} />Save</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── MULTI-STEP APPLY MODAL ── */}
      {applyOpen && (
        <div onClick={() => { setApplyOpen(false); setApplyStep(1); }} style={{ position: "fixed", inset: 0, zIndex: 60, background: "rgba(16,32,25,.55)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "44px 20px", overflowY: "auto", animation: "jsFade .18s ease" }}>
          <div onClick={stop} style={{ width: "100%", maxWidth: 600, background: "#fff", borderRadius: 22, boxShadow: "0 30px 90px rgba(10,30,20,.4)", animation: "jsRise .26s cubic-bezier(.18,.9,.3,1.2)", overflow: "hidden" }}>
            <div style={{ padding: "22px 28px 0", position: "relative" }}>
              <button onClick={() => { setApplyOpen(false); setApplyStep(1); }} className="jsa-close" style={{ position: "absolute", top: 18, right: 18, width: 36, height: 36, borderRadius: 10, border: "none", background: "#f1f5f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Close /></button>
              <div style={{ display: "flex", alignItems: "center", gap: 11, paddingRight: 40 }}>
                <div style={{ flex: "none", width: 40, height: 40, borderRadius: 11, background: (selJob || {}).logoBg, color: (selJob || {}).logoColor, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 17 }}>{(selJob || {}).initial}</div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 12, color: "#8a9a91", fontWeight: 700 }}>Applying for</div>
                  <div style={{ fontSize: 15.5, fontWeight: 800, letterSpacing: "-.01em", lineHeight: 1.2 }}>{(selJob || {}).title} · {(selJob || {}).company}</div>
                </div>
              </div>
              {applyStep <= 3 && (
                <div style={{ display: "flex", gap: 7, margin: "20px 0 0" }}>
                  {["Resume", "Questions", "Review"].map((label, i) => {
                    const n = i + 1;
                    return (
                      <div key={label} style={{ flex: 1 }}>
                        <div style={{ height: 5, borderRadius: 999, background: applyStep >= n ? "#009b57" : "#e3e9e4" }} />
                        <div style={{ marginTop: 7, fontSize: 11.5, fontWeight: 700, color: applyStep >= n ? "#047a45" : "#9aa89f" }}>{label}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ padding: "22px 28px" }}>
              {applyStep === 1 && (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 13 }}>
                    <div><label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Full name</label><input value={ad.name} onChange={(e) => setAd("name", e.target.value)} className="jsa-input" style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }} /></div>
                    <div><label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Phone</label><input value={ad.phone} maxLength="11" type="number" onChange={(e) => setAd("phone", e.target.value)} className="jsa-input" style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }} /></div>
                  </div>
                  <div><label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Email</label><input value={ad.email} onChange={(e) => setAd("email", e.target.value)} className="jsa-input" style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }} /></div>
                  <div>
                    <label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Resume</label>
                    <div onClick={() => { setAd("resumeAttached", !ad.resumeAttached); }} style={{ display: "flex", alignItems: "center", gap: 13, padding: 15, border: "1.5px " + (ad.resumeAttached ? "solid" : "dashed") + " " + (ad.resumeAttached ? "#bfe4d0" : "#dde5df"), borderRadius: 13, background: ad.resumeAttached ? "#f3faf6" : "#fafcfb", cursor: "pointer" }}>
                      {/* <div type ="file" style={{ flex: "none", width: 40, height: 40, borderRadius: 10, background: ad.resumeAttached ? "#d9f0e2" : "#eef2ee", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Ic type ="file" s={19}><path d="M14 3v5h5" stroke={ad.resumeAttached ? "#047a45" : "#8a9a91"} strokeWidth="1.8" strokeLinejoin="round" /><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" stroke={ad.resumeAttached ? "#047a45" : "#8a9a91"} strokeWidth="1.8" strokeLinejoin="round"  /></Ic>
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: "#16271f" }}>{ad.resumeAttached ? (displayName ? displayName.replace(/\s+/g, "_") + "_CV.pdf" : ad.resumeAttached) : "No resume attached"}</div>
                        <div style={{ fontSize: 12.5, color: "#8a9a91", fontWeight: 600 }}>{ad.resumeAttached ? ad.resumeAttached : "Tap to attach your profile resume"}</div>
                      </div>
                      <span style={{ flex: "none", fontSize: 13, fontWeight: 700, color: "#009b57" }}>{ad.resumeAttached ? "Replace" : "Attach"}</span> */}
                      <Input
                        type="file"
                        className="form-control"
                        id="inputGroupFile01"
                        onChange={UploadResume}
                      />
                    </div>
                  </div>
                  <div><label style={{ display: "block", fontSize: 12.5, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Cover note <span style={{ color: "#9aa89f", fontWeight: 600 }}>(optional)</span></label><textarea value={ad.note} onChange={(e) => setAd("note", e.target.value)} placeholder="A short message to the hiring team…" className="jsa-textarea" style={{ width: "100%", minHeight: 84, padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none", resize: "vertical" }} /></div>
                </div>
              )}

              {applyStep === 2 && (
                <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                  <div>
                    <label style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#16271f", marginBottom: 9 }}>How many years of relevant experience do you have?</label>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {["0–1 years", "1–3 years", "3–5 years", "5+ years"].map((v) => filterPill(v, ad.exp === v, () => setAd("exp", v)))}
                    </div>
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#16271f", marginBottom: 9 }}>Are you authorized to work in the Philippines?</label>
                    <div style={{ display: "flex", gap: 8 }}>
                      {["Yes", "No"].map((v) => <button key={v} onClick={() => setAd("auth", v)} style={{ padding: "9px 18px", borderRadius: 100, border: "1.5px solid " + (ad.auth === v ? "#009b57" : "#dde5df"), background: ad.auth === v ? "#009b57" : "#fff", color: ad.auth === v ? "#fff" : "#3c4d44", fontFamily: "inherit", fontSize: 13.5, fontWeight: 600, cursor: "pointer" }}>{v}</button>)}
                    </div>
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#16271f", marginBottom: 9 }}>Expected monthly salary</label>
                    {/* <input value={ad.salary} onChange={(e) => onChangeSalary(e)} placeholder="e.g. ₱80,000" className="jsa-input" style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }} /> */}
                    <CurrencyInput
                      className="jsa-input" 
                      id="currency-input"
                      name="currency"
                      placeholder="Please enter a number"
                      defaultValue={ad.salary}
                      decimalsLimit={2}
                      maxLength={12}
                      onValueChange={onChangeSalary}
                      style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }}
                    />
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 13.5, fontWeight: 700, color: "#16271f", marginBottom: 9 }}>When can you start?</label>
                    <input value={ad.start} onChange={(e) => setAd("start", e.target.value)} placeholder="e.g. Immediately / 30 days" className="jsa-input" style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #dde5df", borderRadius: 11, fontFamily: "inherit", fontSize: 14, outline: "none" }} />
                  </div>
                </div>
              )}

              {applyStep === 3 && (
                <div style={{ display: "flex", flexDirection: "column", gap: 11 }}>
                  <Alert style={{width : "100%"}} isOpen={isshow} color={color} fade={fade} className={isshow ? 'display-block' : 'display-none'}>
                    <div className={color}></div> 
                    <b>{message}</b>
                  </Alert>
                  <div style={{ fontSize: 13.5, color: "#6c7d74", fontWeight: 500, marginBottom: 3 }}>Please review before submitting.</div>
                  {reviewRows.map((rr) => (
                    <div key={rr.k} style={{ display: "flex", gap: 14, justifyContent: "space-between", padding: "12px 0", borderBottom: "1px solid #f0f4f1" }}>
                      <span style={{ flex: "none", width: 150, fontSize: 13, color: "#8a9a91", fontWeight: 700 }}>{rr.k}</span>
                      <span style={{ flex: 1, fontSize: 13.5, color: "#16271f", fontWeight: 600, textAlign: "right" }}>{rr.v}</span>
                    </div>
                  ))}
                </div>
              )}

              {applyStep === 4 && (
                <div style={{ textAlign: "center", padding: "18px 0 8px" }}>
                  <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#ecf7f0", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}><Check s={36} stroke="#009b57" w={2.6} /></div>
                  <h2 style={{ margin: 0, fontSize: 21, fontWeight: 800, letterSpacing: "-.02em" }}>Application submitted!</h2>
                  <p style={{ margin: "9px auto 0", fontSize: 14.5, color: "#6c7d74", fontWeight: 500, lineHeight: 1.55, maxWidth: 380 }}>Your application for <strong style={{ color: "#16271f" }}>{(selJob || {}).title}</strong> at {(selJob || {}).company} is on its way. You can track its status in My Applications.</p>
                </div>
              )}
            </div>

            <div style={{ padding: "16px 28px", borderTop: "1px solid #eef2ee", display: "flex", gap: 11, alignItems: "center", background: "#fbfdfb" }}>
              {applyStep === 4 ? (
                <>
                  <button onClick={() => { setApplyOpen(false); setApplyStep(1); navigate("/MyApplications"); }} className="jsa-primary" style={{ flex: 1, padding: 13, border: "none", borderRadius: 12, background: "#009b57", color: "#fff", fontFamily: "inherit", fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>Track in My Applications</button>
                  <button onClick={() => { setApplyOpen(false); setApplyStep(1); }} className="jsa-ghost" style={{ flex: "none", padding: "13px 18px", border: "1.5px solid #dde5df", borderRadius: 12, background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>Done</button>
                </>
              ) : (
                <>
                  <button onClick={() => { if (applyStep > 1) setApplyStep(applyStep - 1); else setApplyOpen(false); setisshow(false) }} className="jsa-ghost" style={{ flex: "none", padding: "13px 20px", border: "1.5px solid #dde5df", borderRadius: 12, background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 14.5, fontWeight: 700, cursor: "pointer" }}>{applyStep === 1 ? "Cancel" : "Back"}</button>
                  <button onClick={() => { if (applyStep < 3) setApplyStep(applyStep + 1); else submitApplication(); }} className="jsa-primary" style={{ flex: 1, padding: 13, border: "none", borderRadius: 12, background: "#009b57", color: "#fff", fontFamily: "inherit", fontSize: 15, fontWeight: 700, cursor: "pointer", boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>{applyStep === 3 ? "Submit application" : "Continue"}</button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── JOB ALERTS MODAL ── */}
      {alertsOpen && (
        <div onClick={() => setAlertsOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 60, background: "rgba(16,32,25,.55)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "56px 20px", overflowY: "auto", animation: "jsFade .18s ease" }}>
          <div onClick={stop} style={{ width: "100%", maxWidth: 520, background: "#fff", borderRadius: 22, boxShadow: "0 30px 90px rgba(10,30,20,.4)", animation: "jsRise .26s cubic-bezier(.18,.9,.3,1.2)", overflow: "hidden" }}>
            <div style={{ padding: "24px 26px 20px", position: "relative" }}>
              <button onClick={() => setAlertsOpen(false)} className="jsa-close" style={{ position: "absolute", top: 18, right: 18, width: 36, height: 36, borderRadius: 10, border: "none", background: "#f1f5f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Close /></button>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, letterSpacing: "-.02em" }}>Job alerts</h2>
              <p style={{ margin: "6px 0 0", fontSize: 13.5, color: "#6c7d74", fontWeight: 500 }}>Get notified when new roles match your search.</p>
            </div>
            <div style={{ padding: "0 26px 8px" }}>
              <div style={{ background: "#f6f8f6", borderRadius: 15, padding: 17 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
                  <div><label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Keyword</label><input value={alertDraft.keyword} onChange={(e) => setDraft("keyword", e.target.value)} placeholder="e.g. Frontend" className="jsa-input" style={{ width: "100%", padding: "10px 13px", border: "1.5px solid #dde5df", borderRadius: 10, fontFamily: "inherit", fontSize: 13.5, outline: "none", background: "#fff" }} /></div>
                  <div><label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Location</label><input value={alertDraft.location} onChange={(e) => setDraft("location", e.target.value)} placeholder="e.g. Makati" className="jsa-input" style={{ width: "100%", padding: "10px 13px", border: "1.5px solid #dde5df", borderRadius: 10, fontFamily: "inherit", fontSize: 13.5, outline: "none", background: "#fff" }} /></div>
                </div>
                <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#45564c", marginBottom: 6 }}>Frequency</label>
                <div style={{ display: "flex", gap: 7, marginBottom: 13 }}>
                  {["Instant", "Daily", "Weekly"].map((v) => <button key={v} onClick={() => setDraft("freq", v)} style={{ flex: 1, padding: 9, borderRadius: 10, border: "1.5px solid " + (alertDraft.freq === v ? "#009b57" : "#dde5df"), background: alertDraft.freq === v ? "#009b57" : "#fff", color: alertDraft.freq === v ? "#fff" : "#3c4d44", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>{v}</button>)}
                </div>
                <button onClick={addAlert} className="jsa-primary" style={{ width: "100%", padding: 11, border: "none", borderRadius: 11, background: "#009b57", color: "#fff", fontFamily: "inherit", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Create alert</button>
              </div>
              <div style={{ margin: "18px 0 8px", fontSize: 12, fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase", color: "#8a9a91" }}>Your alerts</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 9, paddingBottom: 18 }}>
                {alerts.map((a) => (
                  <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "13px 15px", border: "1.5px solid #e8ede9", borderRadius: 13 }}>
                    <div style={{ flex: "none", width: 36, height: 36, borderRadius: 10, background: "#ecf7f0", display: "flex", alignItems: "center", justifyContent: "center" }}><Bell s={17} stroke="#047a45" /></div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, color: "#16271f" }}>{a.keyword}</div>
                      <div style={{ fontSize: 12.5, color: "#8a9a91", fontWeight: 600 }}>{(a.location || "Anywhere") + " · " + a.freq}</div>
                    </div>
                    <button onClick={() => setAlerts((s) => s.filter((x) => x.id !== a.id))} style={{ flex: "none", width: 32, height: 32, borderRadius: 9, border: "none", background: "#f6f8f6", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Trash /></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── NOTIFICATION DETAIL MODAL ── */}
      {selectedNotif != null && (
        <div onClick={() => setSelectedNotif(null)} style={{ position: "fixed", inset: 0, zIndex: 50, background: "rgba(16,32,25,.5)", backdropFilter: "blur(3px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "64px 20px", overflowY: "auto", animation: "jsFade .18s ease" }}>
          <div onClick={stop} style={{ width: "100%", maxWidth: 520, background: "#fff", borderRadius: 22, boxShadow: "0 30px 90px rgba(10,30,20,.4)", animation: "jsRise .26s cubic-bezier(.18,.9,.3,1.2)", overflow: "hidden" }}>
            <div style={{ padding: "24px 26px", position: "relative" }}>
              <button onClick={() => setSelectedNotif(null)} className="jsa-close" style={{ position: "absolute", top: 18, right: 18, width: 34, height: 34, borderRadius: 10, border: "none", background: "#f1f5f2", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><Close s={15} /></button>
              <div style={{ display: "flex", gap: 14, alignItems: "center", paddingRight: 30 }}>
                <div style={{ flex: "none", width: 54, height: 54, borderRadius: 14, background: selNotif.bg, color: selNotif.color, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 22 }}>{selNotif.initial}</div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: selNotif.color }}>{selNotif.company} · {selNotif.tag}</div>
                  <h2 style={{ margin: "4px 0 0", fontSize: 19, fontWeight: 800, letterSpacing: "-.01em", lineHeight: 1.25 }}>{selNotif.title}</h2>
                </div>
              </div>
              <p style={{ margin: "20px 0 0", fontSize: 14.5, lineHeight: 1.65, color: "#3c4d44" }}>{selNotif.message}</p>
              <div style={{ marginTop: 8, fontSize: 12.5, color: "#9aa89f", fontWeight: 600 }}>{selNotif.time}</div>
            </div>
            <div style={{ padding: "16px 26px", borderTop: "1px solid #eef2ee", display: "flex", gap: 11, background: "#fbfdfb" }}>
              <button className="jsa-primary" style={{ flex: 1, padding: 12, border: "none", borderRadius: 12, background: "#009b57", color: "#fff", fontFamily: "inherit", fontSize: 14.5, fontWeight: 700, cursor: "pointer", boxShadow: "0 5px 14px rgba(0,154,87,.3)" }}>{selNotif.cta}</button>
              <button onClick={() => setSelectedNotif(null)} className="jsa-ghost" style={{ flex: "none", padding: "12px 18px", border: "1.5px solid #dde5df", borderRadius: 12, background: "#fff", color: "#2c3d34", fontFamily: "inherit", fontSize: 14.5, fontWeight: 700, cursor: "pointer" }}>Dismiss</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
